import styled from 'styled-components';

export const TabsRow = styled.div`
  display: flex;
  gap: 0.8rem;
  margin-bottom: 1.6rem;
  flex-wrap: wrap;
`;

export const Tab = styled.button<{ $active: boolean; $accent: string }>`
  padding: 0.6rem 1.4rem;
  border-radius: 2rem;
  border: 0.1rem solid
    ${({ $active, $accent, theme }) =>
      $active ? $accent : theme.colors.border};
  background-color: ${({ $active, $accent, theme }) =>
    $active ? $accent : theme.colors.white};
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.white : theme.colors.slateGrey};
  cursor: pointer;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.8rem;
`;

export const Tile = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  border-radius: 0.8rem;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.surface};
  cursor: pointer;
`;

export const TileMedia = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const PlayBadge = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: ${({ theme }) => theme.colors.white};
  width: 3.6rem;
  height: 3.6rem;
  border-radius: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
`;

export const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const LightboxContent = styled.div`
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  img,
  video {
    max-width: 90vw;
    max-height: 85vh;
    object-fit: contain;
  }
`;

export const LightboxCaption = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.4rem;
  margin-top: 1.2rem;
  text-align: center;
`;

export const LightboxNav = styled.button<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(255, 255, 255, 0.15);
  color: ${({ theme }) => theme.colors.white};
  border: none;
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 2.4rem;
  font-size: 3.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $side }) => ($side === 'left' ? 'left: 1.6rem;' : 'right: 1.6rem;')}

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const LightboxClose = styled.button`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  background-color: rgba(255, 255, 255, 0.15);
  color: ${({ theme }) => theme.colors.white};
  border: none;
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
  font-size: 1.8rem;
  cursor: pointer;
`;
